import { connect } from 'react-redux';
import { compose } from 'recompact';

import { errorBoundary } from 'src/app/hocs';
import { closeModal } from 'src/app/state/actions';
import type { Dispatch, RootState } from 'src/app/state/store';

import { OkModalRenderer } from '.';

function makeMapStateToProps() {
  return (state: RootState) => {
    const confirmMessage = state?.modal?.confirmMessage;

    return {
      confirmMessage,
    };
  };
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  dispatchCloseModal: () => dispatch(closeModal()),
});

export const Ok = compose(errorBoundary, connect(makeMapStateToProps, mapDispatchToProps))(OkModalRenderer);
